import {AxiosInstance} from 'axios'
import MyAxiosInstancePriceResearch from './axiosInstancePriceResearch'
import {
    ConsultaDetail,
    ConsultaList,
    ConsultaOut,
    DadosPfCertidoes,
    FornecedorBuscaOut,
} from '../types/radarFornecedor'

export class RadarFornecedorApiService {
    private api: AxiosInstance

    constructor() {
        this.api = MyAxiosInstancePriceResearch
    }

    // Período: decisão de produto (23/07/2026) — o Radar cobre SEMPRE os últimos 5 anos;
    // o front não envia periodo_meses (o backend aplica o default de 60 meses).
    // O campo `cnpj` é o DOCUMENTO consultado (nome histórico): aceita 14 dígitos (CNPJ)
    // ou 11 (CPF — pessoa física); o backend deduz o tipo pelo comprimento e devolve
    // `tipo_documento` no resultado.
    async criarConsulta(cnpj: string, nome?: string): Promise<ConsultaOut> {
        const {data} = await this.api.post('/fornecedores', {
            cnpj,
            nome: nome || undefined,
        })
        return data
    }

    async buscarPorNome(nome: string): Promise<FornecedorBuscaOut> {
        const {data} = await this.api.get('/fornecedores/buscar', {
            params: {nome},
        })
        return data
    }

    async getConsulta(id: string): Promise<ConsultaDetail> {
        const {data} = await this.api.get(`/fornecedores/${id}`)
        return data
    }

    async listarConsultas(limit = 20, offset = 0): Promise<ConsultaList> {
        const {data} = await this.api.get('/fornecedores', {
            params: {limit, offset},
        })
        return data
    }

    async removerConsulta(id: string): Promise<void> {
        await this.api.delete(`/fornecedores/${id}`)
    }

    async exportarPdf(id: string): Promise<Blob> {
        const {data} = await this.api.get(`/fornecedores/${id}/pdf`, {
            responseType: 'blob',
        })
        return data
    }

    // EMISSÃO SELETIVA (checkbox por certidão): emite SÓ as certidões escolhidas (`tipos` =
    // valores de TipoCertidao). 202 + push. Cada certidão é uma emissão paga — por isso o
    // usuário escolhe quais emitir; o backend consulta somente os tipos recebidos.
    // `dadosPf` só existe na consulta de CPF (emissão PF destravada 27/08/2026): dados do
    // titular que algumas certidões exigem — CPF_SITUACAO (data_nascimento),
    // ANTECEDENTES_CRIMINAIS (nome + data_nascimento + nome_mae), MPT_FEITOS (uf) — vão
    // como `dados_pf` no body; omitido, o body segue idêntico ao de CNPJ.
    async solicitarCertidoes(
        id: string,
        tipos: string[],
        dadosPf?: DadosPfCertidoes
    ): Promise<ConsultaOut> {
        const {data} = await this.api.post(`/fornecedores/${id}/certidoes`, {
            tipos,
            ...(dadosPf ? {dados_pf: dadosPf} : {}),
        })
        return data
    }
}
